// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../commonapis/gen/buhta_common_v1_org_type.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account from "./buhta_document_v1alpha1_contractor_bank_account.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1alpha1_contractor.ml",
  94,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Contractor"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "$$Document"
    ]]
});

const $$Document = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1alpha1_contractor.ml",
  150,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Contractor"
          ]]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1alpha1_contractor.ml",
  204,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Contractor"
    ]]
});

const Contractor = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1alpha1_contractor.ml",
  256,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.document.v1alpha1.Contractor";
}

function make(idOpt, tinOpt, type$pOpt, country_codeOpt, residentOpt, nameOpt, refnumOpt, emailOpt, phoneOpt, contactOpt, legal_addressOpt, real_addressOpt, chief_tinOpt, chief_positionOpt, chief_family_nameOpt, chief_given_nameOpt, chief_patronymic_nameOpt, chief_acting_onOpt, kbeOpt, default_bank_account, bank_accountsOpt, create_time, update_time, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const tin = tinOpt !== undefined ? tinOpt : "";
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0);
  const country_code = country_codeOpt !== undefined ? country_codeOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const name = nameOpt !== undefined ? nameOpt : "";
  const refnum = refnumOpt !== undefined ? refnumOpt : "";
  const email = emailOpt !== undefined ? emailOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  const contact = contactOpt !== undefined ? contactOpt : "";
  const legal_address = legal_addressOpt !== undefined ? legal_addressOpt : "";
  const real_address = real_addressOpt !== undefined ? real_addressOpt : "";
  const chief_tin = chief_tinOpt !== undefined ? chief_tinOpt : "";
  const chief_position = chief_positionOpt !== undefined ? chief_positionOpt : "";
  const chief_family_name = chief_family_nameOpt !== undefined ? chief_family_nameOpt : "";
  const chief_given_name = chief_given_nameOpt !== undefined ? chief_given_nameOpt : "";
  const chief_patronymic_name = chief_patronymic_nameOpt !== undefined ? chief_patronymic_nameOpt : "";
  const chief_acting_on = chief_acting_onOpt !== undefined ? chief_acting_onOpt : "";
  const kbe = kbeOpt !== undefined ? kbeOpt : "";
  const bank_accounts = bank_accountsOpt !== undefined ? bank_accountsOpt : /* [] */ 0;
  return {
    id: id,
    tin: tin,
    "type'": type$p,
    country_code: country_code,
    resident: resident,
    name: name,
    refnum: refnum,
    email: email,
    phone: phone,
    contact: contact,
    legal_address: legal_address,
    real_address: real_address,
    chief_tin: chief_tin,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    chief_acting_on: chief_acting_on,
    kbe: kbe,
    default_bank_account: default_bank_account,
    bank_accounts: bank_accounts,
    create_time: create_time,
    update_time: update_time
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "type",
    "type"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
  Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
]));

const merge_country_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "country_code",
    "countryCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "resident",
    "resident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_refnum = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    7,
    "refnum",
    "refnum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    8,
    "email",
    "email"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    9,
    "phone",
    "phone"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_contact = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    10,
    "contact",
    "contact"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_legal_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    11,
    "legal_address",
    "legalAddress"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_real_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    12,
    "real_address",
    "realAddress"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    16,
    "chief_tin",
    "chiefTin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    17,
    "chief_position",
    "chiefPosition"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    18,
    "chief_family_name",
    "chiefFamilyName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    19,
    "chief_given_name",
    "chiefGivenName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    20,
    "chief_patronymic_name",
    "chiefPatronymicName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_acting_on = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    21,
    "chief_acting_on",
    "chiefActingOn"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_kbe = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    30,
    "kbe",
    "kbe"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;

const merge_default_bank_account = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    31,
    "default_bank_account",
    "defaultBankAccount"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

const $$let$1 = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;

const merge_bank_accounts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    32,
    "bank_accounts",
    "bankAccounts"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    33,
    "create_time",
    "createTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  })
]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_update_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    34,
    "update_time",
    "updateTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    tin: Curry._2(merge_tin, t1.tin, t2.tin),
    "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
    country_code: Curry._2(merge_country_code, t1.country_code, t2.country_code),
    resident: Curry._2(merge_resident, t1.resident, t2.resident),
    name: Curry._2(merge_name, t1.name, t2.name),
    refnum: Curry._2(merge_refnum, t1.refnum, t2.refnum),
    email: Curry._2(merge_email, t1.email, t2.email),
    phone: Curry._2(merge_phone, t1.phone, t2.phone),
    contact: Curry._2(merge_contact, t1.contact, t2.contact),
    legal_address: Curry._2(merge_legal_address, t1.legal_address, t2.legal_address),
    real_address: Curry._2(merge_real_address, t1.real_address, t2.real_address),
    chief_tin: Curry._2(merge_chief_tin, t1.chief_tin, t2.chief_tin),
    chief_position: Curry._2(merge_chief_position, t1.chief_position, t2.chief_position),
    chief_family_name: Curry._2(merge_chief_family_name, t1.chief_family_name, t2.chief_family_name),
    chief_given_name: Curry._2(merge_chief_given_name, t1.chief_given_name, t2.chief_given_name),
    chief_patronymic_name: Curry._2(merge_chief_patronymic_name, t1.chief_patronymic_name, t2.chief_patronymic_name),
    chief_acting_on: Curry._2(merge_chief_acting_on, t1.chief_acting_on, t2.chief_acting_on),
    kbe: Curry._2(merge_kbe, t1.kbe, t2.kbe),
    default_bank_account: Curry._2(merge_default_bank_account, t1.default_bank_account, t2.default_bank_account),
    bank_accounts: Curry._2(merge_bank_accounts, t1.bank_accounts, t2.bank_accounts),
    create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
    update_time: Curry._2(merge_update_time, t1.update_time, t2.update_time)
  };
}

function spec(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;
  const $$let$1 = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "type",
      "type"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
    Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "country_code",
      "countryCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "resident",
      "resident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      7,
      "refnum",
      "refnum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      8,
      "email",
      "email"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      9,
      "phone",
      "phone"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      10,
      "contact",
      "contact"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      11,
      "legal_address",
      "legalAddress"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      12,
      "real_address",
      "realAddress"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      16,
      "chief_tin",
      "chiefTin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      17,
      "chief_position",
      "chiefPosition"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      18,
      "chief_family_name",
      "chiefFamilyName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      19,
      "chief_given_name",
      "chiefGivenName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      20,
      "chief_patronymic_name",
      "chiefPatronymicName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      21,
      "chief_acting_on",
      "chiefActingOn"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      30,
      "kbe",
      "kbe"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      31,
      "default_bank_account",
      "defaultBankAccount"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      32,
      "bank_accounts",
      "bankAccounts"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      33,
      "create_time",
      "createTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$2.name,
      make: $$let$2.make,
      from_proto: $$let$2.from_proto,
      from_proto_exn: $$let$2.from_proto_exn,
      to_proto: $$let$2.to_proto,
      to_proto$p: $$let$2.to_proto$p,
      merge: $$let$2.merge,
      to_json: $$let$2.to_json,
      from_json_exn: $$let$2.from_json_exn,
      from_json: $$let$2.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      34,
      "update_time",
      "updateTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$3.name,
      make: $$let$3.make,
      from_proto: $$let$3.from_proto,
      from_proto_exn: $$let$3.from_proto_exn,
      to_proto: $$let$3.to_proto,
      to_proto$p: $$let$3.to_proto$p,
      merge: $$let$3.merge,
      to_json: $$let$3.to_json,
      from_json_exn: $$let$3.from_json_exn,
      from_json: $$let$3.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry.app(serialize, [
    writer,
    param.id,
    param.tin,
    param["type'"],
    param.country_code,
    param.resident,
    param.name,
    param.refnum,
    param.email,
    param.phone,
    param.contact,
    param.legal_address,
    param.real_address,
    param.chief_tin,
    param.chief_position,
    param.chief_family_name,
    param.chief_given_name,
    param.chief_patronymic_name,
    param.chief_acting_on,
    param.kbe,
    param.default_bank_account,
    param.bank_accounts,
    param.create_time,
    param.update_time
  ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, tin, type$p, country_code, resident, name, refnum, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe, default_bank_account, bank_accounts, create_time, update_time) {
  return {
    id: id,
    tin: tin,
    "type'": type$p,
    country_code: country_code,
    resident: resident,
    name: name,
    refnum: refnum,
    email: email,
    phone: phone,
    contact: contact,
    legal_address: legal_address,
    real_address: real_address,
    chief_tin: chief_tin,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    chief_acting_on: chief_acting_on,
    kbe: kbe,
    default_bank_account: default_bank_account,
    bank_accounts: bank_accounts,
    create_time: create_time,
    update_time: update_time
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.Contractor", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.id,
      param.tin,
      param["type'"],
      param.country_code,
      param.resident,
      param.name,
      param.refnum,
      param.email,
      param.phone,
      param.contact,
      param.legal_address,
      param.real_address,
      param.chief_tin,
      param.chief_position,
      param.chief_family_name,
      param.chief_given_name,
      param.chief_patronymic_name,
      param.chief_acting_on,
      param.kbe,
      param.default_bank_account,
      param.bank_accounts,
      param.create_time,
      param.update_time
    ]);
  };
}

function constructor$1(id, tin, type$p, country_code, resident, name, refnum, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe, default_bank_account, bank_accounts, create_time, update_time) {
  return {
    id: id,
    tin: tin,
    "type'": type$p,
    country_code: country_code,
    resident: resident,
    name: name,
    refnum: refnum,
    email: email,
    phone: phone,
    contact: contact,
    legal_address: legal_address,
    real_address: real_address,
    chief_tin: chief_tin,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    chief_acting_on: chief_acting_on,
    kbe: kbe,
    default_bank_account: default_bank_account,
    bank_accounts: bank_accounts,
    create_time: create_time,
    update_time: update_time
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.Contractor", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Contractor, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Contractor"
    ]]
}, V1alpha1, {
  Contractor: Contractor
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Contractor"
          ]]
      },
      "V1alpha1"
    ]]
}, $$Document, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Contractor"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "$$Document"
    ]]
}, Buhta, {
  $$Document: $$Document
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
